var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open_vip"},[_c('div',{staticClass:"vip_top"},[_c('div',{staticClass:"title"},[_vm._v("备战考试 圆梦理想")]),_c('img',{attrs:{"src":require("../assets/images/vip.png"),"alt":""}})]),_c('div',{staticClass:"vip_bottom"},[_c('div',{staticClass:"title"},[_vm._v("2026年体育单招考试运动员文化课辅导在线网课平台！")])])])
}]

export { render, staticRenderFns }